export class PlannedWeeklyHours {
    plannedHours: number;
    plannedHoursInMinutes: number;
    hrPlannedHours:  string;
    traveledTimeHours: number;
    traveledTimeInMinutes: number;
    hrTraveledHours: null;
    workerWeeklyHours: number;
    workerWeeklyHoursInMinutes: number;
    available: number;
    availableInMinutes: number;
    hrAvailableHours:  string;
    nightPlannedHours: number;
    nightPlannedHoursInMinutes: number;
    hrPlannedNightHours: string;
    tsPlannedHours: number;
    hrTsPlannedHours:  string
}

export class EffectiveWeeklyHours {
    effectiveHours: number;
    effectiveHoursInMinutes: number;
    hrEffectiveHours:  string;
    traveledTimeHours: number;
    traveledTimeInMinutes: number;
    hrTraveledHours: null;
    workerWeeklyHours: number;
    workerWeeklyHoursInMinutes: number;
    balance: number;
    balanceInMinutes: number;
    hrBalanceHours:  string;
    nightEffectiveHours: number;
    nightEffectiveHoursInMinutes: number;
    hrEffectiveNightHours:  string;
    tsEffectiveHours: number;
    hrTsEffectiveHours:  string;
    yearlyRecoveryWorkingHours: number;
    hrTsYearlyRecoveryWorkingHours:  string
}

export class WorkingHoursData {
    detailedView: boolean;
    plannedWeeklyHours: PlannedWeeklyHours;
    effectiveWeeklyHours: EffectiveWeeklyHours;
    
    static FromJson(o: any): WorkingHoursData{
              
        let p = new PlannedWeeklyHours();
        p.plannedHours = o.plannedWeeklyHoursDto?.plannedHours;
        p.plannedHoursInMinutes = o.plannedWeeklyHoursDto?.plannedHoursInMinutes;
        p.hrPlannedHours = o.plannedWeeklyHoursDto?.hrPlannedHours;
        p.traveledTimeHours = o.plannedWeeklyHoursDto?.traveledTimeHours;
        p.traveledTimeInMinutes = o.plannedWeeklyHoursDto?.traveledTimeInMinutes;
        p.hrTraveledHours = o.plannedWeeklyHoursDto?.hrTraveledHours;
        p.workerWeeklyHours = o.plannedWeeklyHoursDto?.workerWeeklyHours;
        p.workerWeeklyHoursInMinutes = o.plannedWeeklyHoursDto?.workerWeeklyHoursInMinutes;
        p.available = o.plannedWeeklyHoursDto?.available;
        p.availableInMinutes = o.plannedWeeklyHoursDto?.availableInMinutes;
        p.hrAvailableHours = o.plannedWeeklyHoursDto?.hrAvailableHours;
        p.nightPlannedHours = o.plannedWeeklyHoursDto?.nightPlannedHours;
        p.nightPlannedHoursInMinutes = o.plannedWeeklyHoursDto?.nightPlannedHoursInMinutes;
        p.hrPlannedNightHours = o.plannedWeeklyHoursDto?.hrPlannedNightHours;
        p.tsPlannedHours = o.plannedWeeklyHoursDto?.tsPlannedHours;
        p.hrTsPlannedHours = o.plannedWeeklyHoursDto?.hrTsPlannedHours
        
        let e = new EffectiveWeeklyHours();
        e.effectiveHours = o.effectiveWeeklyHoursDto?.effectiveHours;
        e.effectiveHoursInMinutes = o.effectiveWeeklyHoursDto?.effectiveHoursInMinutes;
        e.hrEffectiveHours = o.effectiveWeeklyHoursDto?.hrEffectiveHours;
        e.traveledTimeHours = o.effectiveWeeklyHoursDto?.traveledTimeHours;
        e.traveledTimeInMinutes = o.effectiveWeeklyHoursDto?.traveledTimeInMinutes;
        e.hrTraveledHours = o.effectiveWeeklyHoursDto?.hrTraveledHours;
        e.workerWeeklyHours = o.effectiveWeeklyHoursDto?.workerWeeklyHours;
        e.workerWeeklyHoursInMinutes = o.effectiveWeeklyHoursDto?.workerWeeklyHoursInMinutes;
        e.balance = o.effectiveWeeklyHoursDto?.balance;
        e.balanceInMinutes = o.effectiveWeeklyHoursDto?.balanceInMinutes;
        e.hrBalanceHours = o.effectiveWeeklyHoursDto?.hrBalanceHours;
        e.nightEffectiveHours = o.effectiveWeeklyHoursDto?.nightEffectiveHours;
        e.nightEffectiveHoursInMinutes = o.effectiveWeeklyHoursDto?.nightEffectiveHoursInMinutes;
        e.hrEffectiveNightHours = o.effectiveWeeklyHoursDto?.hrEffectiveNightHours;
        e.tsEffectiveHours = o.effectiveWeeklyHoursDto?.tsEffectiveHours;
        e.hrTsEffectiveHours = o.effectiveWeeklyHoursDto?.hrTsEffectiveHours;
        e.yearlyRecoveryWorkingHours = o.effectiveWeeklyHoursDto?.yearlyRecoveryWorkingHours;
        e.hrTsYearlyRecoveryWorkingHours = o.effectiveWeeklyHoursDto?.hrTsYearlyRecoveryWorkingHours
                
        let w = new WorkingHoursData();
        w.detailedView = o.detailedView;
        w.plannedWeeklyHours = p;
        w.effectiveWeeklyHours = e;
        
        return w;
    }
    
}

export class WorkingHours{
    detailedView: boolean;
    planned: string;
    balance: string;
    effective: string;
    plannedOverfulfilled: boolean;
    effectiveOverfulfilled: boolean;
    showPlannedSection: boolean;
    showEffectiveSection: boolean;
    plannedHours?: string;
    workerWeeklyHours?: string;
    workerWeeklyHoursClass?: string;
    available?: string;
    nightHours?: string;
    yearlyRecoveryWorkingHours?: string;
    effectiveHours?: string;
    effectiveNightHours?: string
}